export class PageNotFoundError extends Error {
	statusCode = 404;

	isArticlePage!: boolean;

	constructor(
		public text?: string,
		isArticlePage = false
	) {
		super(text || 'This page could not be found');
		this.isArticlePage = isArticlePage;
	}
}
